import React, { useEffect } from "react";
import PharmacyItem from "./PharmacyItem";
import ProfileAddress from "./ProfileAddress";
import moment from "moment";
import DrugsContainer from "../containers/DrugsContainer";
import { Heading } from "@reliance/design-system";
import { useTranslation } from "react-i18next";
const p = {
  color: "#333",
  fontSize: "14px",
  fontFamily: "Avenir LT Std",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.15px",
};

const fulfilledMessage = (dispatchStatus, deliveryOption, t) => {
  const deliveryMethod = dispatchStatus.toLowerCase();
  if (deliveryMethod === "delivered" || deliveryMethod === "picked_up") {
    return deliveryOption.toLowerCase() === "homedelivery"
      ? t("successfulPrescriptionDeliveryMessage")
      : t("successfulPrescriptionPickupMessage");
  }
  return deliveryOption.toLowerCase() === "homedelivery"
    ? t("homeDeliveryDispatchCollectionInstruction")
    : t("prescriptionPickupInstruction");
};

const isfFulfilled = (dispatchStatus) => {
  if (
    dispatchStatus.toLowerCase() === "delivered" ||
    dispatchStatus.toLowerCase() === "picked_up"
  ) {
    return true;
  }
  return false;
};

const DeliveredPrescription = ({ code, deliveryMethod, dispatchStatus }) => {
  const { t } = useTranslation("consultations");

  return (
    <div
      className=""
      style={{
        display: "flex",
        padding: "16px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        alignSelf: "stretch",
        borderRadius: "4px",
        border: "1px solid var(--ui-06, #EEE)",
        background: " #FAFDFF",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "8px",
        }}
      >
        <p
          style={{
            color: "var(--primary-color-baby-blue, #107BC0)",
            fontSize: "20px",
            fontFamily: "Avenir LT Std",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "20px",
            letterSpacing: "0.15px",
          }}
        >
          {!isfFulfilled(dispatchStatus) && code}
        </p>
        <p
          style={{
            color: "var(--text-01, #212121)",
            fontSize: "12px",
            fontFamily: "Avenir LT Std",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "normal",
          }}
        >
          {fulfilledMessage(dispatchStatus, deliveryMethod, t)}
        </p>
      </div>
    </div>
  );
};

const DeliveryStatus = ({ setHeader, prescriptions, newFlow }) => {
  const { i18n, t } = useTranslation(["consultations"]);
  const locale = i18n.language === "en" ? "en-ng" : i18n.language;

  const prescriptionCreatedDate = moment(prescriptions?.created_at).locale(
    locale,
  );

  const time = () => {
    if (prescriptionCreatedDate.hour() < 12) {
      return prescriptionCreatedDate.format("ddd, MMMM Do, YYYY");
    }
    return prescriptionCreatedDate.add(1, "days").format("ddd, MMMM Do, YYYY");
  };

  const prescriptionStatus = {
    PENDING: "PENDING" || "pending",
    CANCELLED: "CANCELLED",
    DISPATCHED: "DISPATCHED",
    RECEIVED: "RECEIVED",
    CONFIRMED: "CONFIRMED",
    READY_FOR_PICKUP: "READY_FOR_PICKUP",
    PICKED_UP: "PICKED_UP",
    DELIVERED: "DELIVERED",
    DEACTIVATED: "DEACTIVATED",
  };

  // Function to check if the prescription status is past confirmation stage
  function isPrescriptionPastConfirmation(dispatchStatus) {
    const upperDispatchStatus = dispatchStatus.toUpperCase();
    return (
      upperDispatchStatus === prescriptionStatus.READY_FOR_PICKUP ||
      upperDispatchStatus === prescriptionStatus.DISPATCHED ||
      upperDispatchStatus === prescriptionStatus.PICKED_UP ||
      upperDispatchStatus === prescriptionStatus.DELIVERED
    );
  }

  useEffect(() => {
    setHeader("Prescriptions");
  }, []);

  return (
    <div
      style={{
        display: "flex",
        // width: "365px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
      }}
    >
      {newFlow && <Heading level={"h4"}>{t("prescriptionTitle")}</Heading>}
      <div
        className=""
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {isPrescriptionPastConfirmation(prescriptions.dispatch_status) &&
          !isfFulfilled(prescriptions.dispatch_status) && (
            <p style={p}>{t("prescriptionCode")}</p>
          )}
        {isPrescriptionPastConfirmation(prescriptions.dispatch_status) && (
          <DeliveredPrescription
            code={prescriptions.code}
            deliveryMethod={prescriptions.delivery_option}
            dispatchStatus={prescriptions.dispatch_status}
          />
        )}

        {[prescriptionStatus.PENDING, prescriptionStatus.CONFIRMED].includes(
          prescriptions.dispatch_status.toUpperCase(),
        ) && (
          <div
            style={{
              display: "flex",
              padding: "16px",
              alignItems: "flex-start",
              gap: "16px",
              alignSelf: "stretch",
              borderRadius: "4px",
              background: "var(--ui-04, #F8F8F8)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignSelf: "stretch",
              }}
            >
              {prescriptions.delivery_option.toLowerCase() === "homedelivery"
                ? t("prescriptionCodeNotifyAndDisplayInstructionMessage")
                : t(
                    "prescriptionCodeNotifyAndDisplayDispatchInstructionMessage",
                  )}
            </div>
          </div>
        )}

        {prescriptions.delivery_option.toLowerCase() === "homedelivery" &&
          prescriptions.dispatch_status !== "dispatched" && (
            <>
              <span style={p}>
                {t("prescriptionWillBeDeliveredToLocation")}
              </span>
              <span
                style={{
                  ...p,
                  color: "var(--primary-color-baby-blue, #107BC0)",
                }}
              >
                {time()}
              </span>
            </>
          )}

        {prescriptions &&
          prescriptions.delivery_option.toLowerCase() === "homedelivery" && (
            <React.Fragment>
              <p style={p}>{t("contactDetails")}</p>
              {prescriptions.address ? (
                <ProfileAddress profile={prescriptions} />
              ) : (
                <p>{t("unavailableAddressMessage")}</p>
              )}
            </React.Fragment>
          )}
        {prescriptions &&
          prescriptions.delivery_option.toLowerCase() === "pickup" && (
            <React.Fragment>
              <p style={p}>{t("selectedPharmacy")}</p>
              <PharmacyItem
                pharmacy={{
                  ...prescriptions.provider,
                  delivery_option: "pickup",
                }}
              />
            </React.Fragment>
          )}
        {prescriptions && <DrugsContainer prescriptions={prescriptions} />}
      </div>
    </div>
  );
};

export default DeliveryStatus;
